import { ModelBase } from '../../core/model/model-base';

export class Competence extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.name = dataContext.name;
    }
  }

  name: string;
}
